import { useTranslation } from 'react-i18next';

import NavGroupContainer from './NavGroupContainer';
import NavGroupListContainer from './NavGroupListContainer';
import ThemedNavGroupLink from './ThemedNavGroupLink';
import ThemedNavGroupTitle from './ThemedNavGroupTitle';

interface Props {
  hasMultiplePublications: boolean;
  hasAuthorsPage: boolean;
}

const GeneralNavGroup = ({ hasMultiplePublications, hasAuthorsPage }: Props) => {
  const { t } = useTranslation();
  return (
    <NavGroupContainer>
      <ThemedNavGroupTitle text={t('nav.links.home')} />
      <NavGroupListContainer>
        <ThemedNavGroupLink path={'/'} text={t('meta.titles.posts')} />
        {hasMultiplePublications && <ThemedNavGroupLink path={'/publications'} text="Newsletters" />}
        {hasAuthorsPage && <ThemedNavGroupLink path={'/authors'} text={t('author.authors')} />}
      </NavGroupListContainer>
    </NavGroupContainer>
  );
};

export default GeneralNavGroup;
